import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { isNotNil } from '../../../utils';
import { getScreenComponent, convertScreenComponent } from '../../../api';
import { queryKey } from '../../../constant';

interface UseScreenComponentQueryParams {
  screenName?: string;
  componentId?: number;
  screenLogging?: Record<string, unknown>;
  queryName?: string;
  currentParamValue?: string | null;
  extraParams?: Record<string, string | null>;
}

export const useScreenComponentQuery = ({
  screenName,
  componentId,
  screenLogging,
  queryName,
  currentParamValue,
  extraParams,
}: UseScreenComponentQueryParams) => {
  const enabled =
    isNotNil(screenName) &&
    isNotNil(componentId) &&
    ((isNotNil(queryName) && isNotNil(currentParamValue)) ||
      (isNotNil(extraParams) && Object.keys(extraParams).length > 0));

  return useQuery({
    queryKey: queryKey.screenComponent(
      screenName,
      componentId,
      currentParamValue,
      queryName,
      extraParams,
    ),
    queryFn: () =>
      getScreenComponent({
        screenName: screenName!,
        componentId: componentId!,
        queryParams: {
          ...(extraParams
            ? Object.keys(extraParams).reduce(
                (acc, cur) => ({ ...acc, [cur]: extraParams[cur] }),
                {},
              )
            : {}),
          [queryName!]: currentParamValue!,
        },
      }).then(raw => convertScreenComponent(raw, screenLogging ?? {})),
    enabled,
    placeholderData: keepPreviousData,
  });
};
